import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingCTA from '@/components/feature/FloatingCTA';
import { AuthProvider } from '@/context/AuthContext';

declare const __BASE_PATH__: string;

const AppContent = () => {
  const location = useLocation();
  const isCrm = location.pathname.startsWith('/crm');

  return (
    <>
      {!isCrm && <Navbar />}
      <AppRoutes />
      {!isCrm && <Footer />}
      {!isCrm && <FloatingCTA />}
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
